module.exports = __webpack_public_path__ + "assets/img/imow-splash-299@4x.2647458d.png";